/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Air_Handler_Unit_Exceptional_Planning_Copy_LabelInputs */



/**
* | output |
* | --- |
* | "Copy the exceptional planning of {name} to:" |
*
* @param {Air_Handler_Unit_Exceptional_Planning_Copy_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_exceptional_planning_copy_label = /** @type {((inputs: Air_Handler_Unit_Exceptional_Planning_Copy_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Exceptional_Planning_Copy_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Copy the exceptional planning of ${i?.name} to:`)
	return /** @type {LocalizedString} */ (`Copier le planning exceptionnel de ${i?.name} vers :`)
});